import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { ProtectedRoute } from './components/routing/ProtectedRoute';
import { getDashboardPath, PlantDashboard, PlantOperatorDashboardRoute, OEMServiceDashboardRoute, OEMEngineeringDashboardRoute, QualityDashboard } from './components/routing/DashboardRouter';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/LoginPage';
import { UnauthorizedPage } from './pages/UnauthorizedPage';
import { SimulationPage } from './pages/SimulationPage';
import { LineBVisualization } from './components/simulation/LineBVisualization';
import { useAuth } from './contexts/AuthContext';

function DashboardRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={getDashboardPath(user.role)} replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardRedirect />} />
        <Route path="dashboard" element={<DashboardRedirect />} />
        <Route path="dashboard/plant-operator" element={<PlantOperatorDashboardRoute />} />
        <Route path="dashboard/plant" element={<PlantDashboard />} />
        <Route path="dashboard/oem-service" element={<OEMServiceDashboardRoute />} />
        <Route path="dashboard/oem-engineering" element={<OEMEngineeringDashboardRoute />} />
        <Route path="dashboard/quality" element={<QualityDashboard />} />
        <Route path="simulation" element={<SimulationPage />} />
        <Route path="line-b" element={<LineBVisualization />} />
      </Route>
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <WebSocketProvider>
          <AppRoutes />
        </WebSocketProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;